<template>
    <div class="WorkOrderHourlyRateOptions">
        <div class="row">
            <FormToggle v-model="hourlyRateOptions.precheckTime"/>
            <h4>{{ isMaterial ? 'Include' : 'Bill' }} Pre Trip Time</h4>
        </div>
        <div class="row">
            <FormToggle v-model="hourlyRateOptions.mobilizationTime"/>
            <h4>{{ isMaterial ? 'Include' : 'Bill' }} Mobilization Time (Travel to Work Order)</h4>
        </div>
        <div class="row">
            <FormToggle v-model="hourlyRateOptions.standbyTime"/>
            <h4>{{ isMaterial ? 'Include' : 'Bill' }} Standby Time</h4>
        </div>
        <div class="row">
            <FormToggle v-model="hourlyRateOptions.demobilizationTime"/>
            <h4>{{ isMaterial ? 'Include' : 'Bill' }} Demobilization Time (Travel to Yard)</h4>
        </div>
        <div class="row">
            <FormToggle v-model="hourlyRateOptions.postcheckTime"/>
            <h4>{{ isMaterial ? 'Include' : 'Bill' }} Post Trip Time</h4>
        </div>
    </div>
</template>


<script>
export default {
    name: 'WorkOrderHourlyRateOptions',

    props: {
        hourlyRateOptions: { type: Object, required: true },
        isMaterial: { type: Boolean, default: false },
    },

    methods: {
        handleUpdateHourlyRateOptions(key, value) {
            this.hourlyRateOptions = {
                ...this.hourlyRateOptions,
                [key]: value,
            };

            this.$emit('update:hourlyRateOptions', this.this.hourlyRateOptions);
        },
    },
};
</script>


<style lang="scss" scoped>
@import 'globals.scss';

.WorkOrderHourlyRateOptions {
    .row {
        display: flex;
        align-items: center;
        margin-bottom: 15px;

        h4 {
            margin: 0;
        }

        .FormToggle {
            margin-right: 15px;
        }
    }
}
</style>
